var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('link',{attrs:{"rel":"stylesheet","href":"./assets/markdown.css"}}),_c('Navbar'),_c('v-content',[_c('transition',{attrs:{"name":"slide-x-transition","mode":"out-in","appear":""}},[_c('router-view')],1)],1),_c('Bottom')],1)}
var staticRenderFns = []

export { render, staticRenderFns }